import { useTranslation } from "react-i18next";
import FlatList from "src/components/FlatList";
import NetworkStudentCard from "src/components/network/NetworkStudentCard";
import useGet from "src/hooks/rest/useGet";

export default function NetworkCompanyView() {
	const { t } = useTranslation("network-view", {
		keyPrefix: "network-company-view",
	});
	const [result, loading, { fetchNext, handleSearch, setResult }] = useGet(
		"/connections",
		{ data: [] },
		true
	);
	const { data, hasMore, meta } = result;
	const total = meta?.total || 0;
	return (
		<>
			<FlatList
				{...{ loading, hasMore, handleSearch }}
				title={t("title", {
					count: total,
				})}
				data={data || []}
				onNext={async () => {
					if (hasMore) await fetchNext();
				}}
				columns={3}
				empty={{
					title: t("empty"),
				}}
				renderItem={(row: any) => (
					<NetworkStudentCard
						onSubmit={(profile) => {
							setResult({
								...result,
								meta: {
									...result.meta,
									total: result.meta.total - 1,
								},
								data: result.data.filter(
									(p: any) => p.hid !== profile.hid
								),
							});
						}}
						key={row.hid}
						profile={row}
					/>
				)}
			/>
		</>
	);
}
